// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"button_PrimaryButton__wuewo","cancelButton":"button_cancelButton__5qKmx","deleteBtn":"button_deleteBtn__3RBSw"};